<template>
    <div class="row col-12 p-0 m-0">
        <div v-if="!chat" class="col-12 col-sm-12 col-md-6 col-lg-6 mt-4">
            <div class="form-row">
                <h4 class="mb-2 mr-auto align-self-end" v-if="!expandable">
                    <i class="fa fa-comment mr-2" aria-hidden="true"></i>
                    {{ user_comment_section_name }}</h4>
                <h5 class="mb-2 mr-auto align-self-end" style="line-height: 1.5" v-else>
                    {{ user_comment_section_name }}</h5>
                <template v-if="can_user_comment">
                    <a v-if="button" class="btn btn-primary mt-3 mt-md-0 ml-2 ml-md-0 d-print-none"
                       @click.prevent="getData(true)" href="#"
                       data-toggle="modal"
                       data-target="#modal-table"
                    >{{$lang('Dodaj komentarz')}}</a>
                    <a v-else @click.prevent="getData(true)" href="#" class="d-print-none"
                       data-toggle="modal"
                       data-target="#modal-table"
                       :title="$lang('Dodaj komentarz')" >
                        <i class="fa fa-plus tile icon fa-lg mr-3"
                           style="vertical-align: bottom"
                        ></i>
                    </a>
                </template>
            </div>
            <hr class="colorgraph d-print-none">
            <toast-comment v-for="comment in customer_comments" v-bind:key="comment.id" class="print-no-break"
                           :comment="comment"
                           :status_name="comment.statusName"
                           :time="comment.showable_time">
            </toast-comment>
            <dd v-if="comments.length<=0">{{ $lang('Brak komentarzy') }}</dd>
        </div>
        <div v-if="!chat" class="col-12 col-sm-12 col-md-6 col-lg-6 mt-4">
            <div class="form-row">
                <h4 class="mb-2 mr-auto align-self-end" v-if="!expandable">
                    <i class="fa fa-comment mr-2" aria-hidden="true"></i>
                    {{ admin_comment_section_name }}</h4>
                <h5 class="mb-2 mr-auto align-self-end" style="line-height: 1.5" v-else>
                    {{ admin_comment_section_name }}</h5>
                <template v-if="can_admin_comment && edit_mode">
                    <a v-if="button" href="#" @click.prevent="getData(false)" class="btn btn-primary mt-3 mt-md-0 ml-2 ml-md-0 d-print-none"
                       data-toggle="modal"
                       data-target="#modal-table">
                        {{$lang('Dodaj komentarz')}}
                    </a>
                    <a v-else @click.prevent="getData(false)" href="#" class="d-print-none"
                       data-toggle="modal"
                       data-target="#modal-table"
                       :title="$lang('Dodaj opis oceny')">
                        <i class="fa fa-plus tile icon fa-lg mr-3"
                           style="vertical-align: bottom"
                        ></i>
                    </a>
                </template>

            </div>
            <hr class="colorgraph d-print-none">
            <toast-comment v-for="comment in consultant_comments" v-bind:key="comment.id" class="print-no-break"
                           :comment="comment"
                           :status_name="comment.statusName"
                           :time="comment.showable_time">
            </toast-comment>
            <dd v-if="consultant_comments.length<=0">{{ $lang('Brak komentarzy') }}</dd>
        </div>
        <div v-if="chat" :class="['col-12', expandable ? 'mt-2' : 'mt-4']">
            <div class="form-row mb-3 mr-1">
                <h4 class="mb-2 mr-auto">
                    <template v-if="!expandable">
                        <i class="fa fa-comment mr-2" aria-hidden="true"></i>
                        {{ $lang('Komentarze') }}
                    </template>
                </h4>
                <template v-if="can_admin_comment && edit_mode">
                    <a v-if="button" href="#" @click.prevent="getData(false)" class="btn btn-primary mt-3 mt-md-0 ml-2 ml-md-0 d-print-none"
                       data-toggle="modal"
                       data-target="#modal-table">
                        {{$lang('Dodaj komentarz')}}
                    </a>
                    <a v-else @click.prevent="getData(false)" href="#" class="d-print-none"
                       data-toggle="modal"
                       data-target="#modal-table"
                       :title="$lang('Dodaj opis oceny')">
                        <i class="fa fa-plus tile icon fa-lg mr-3"
                           style="vertical-align: bottom"
                        ></i>
                    </a>
                </template>
                <template v-else-if="can_user_comment">
                    <a v-if="button" class="btn btn-primary mt-3 mt-md-0 ml-2 ml-md-0 d-print-none"
                       @click.prevent="getData(true)" href="#"
                       data-toggle="modal"
                       data-target="#modal-table"
                    >{{$lang('Dodaj komentarz')}}</a>
                    <a v-else @click.prevent="getData(true)" href="#" class="d-print-none"
                       data-toggle="modal"
                       data-target="#modal-table"
                       :title="$lang('Dodaj komentarz')" >
                        <i class="fa fa-plus tile icon fa-lg mr-3"
                           style="vertical-align: bottom"
                        ></i>
                    </a>
                </template>

            </div>
            <toast-comment v-for="comment in comments" v-bind:key="comment.id" class="print-no-break"
                           :comment="comment"
                           :status_name="comment.statusName"
                           :time="comment.showable_time">
            </toast-comment>
            <dd v-if="comments.length<=0">{{ $lang('Brak komentarzy') }}</dd>
        </div>

        <!--            MODAL-->
        <div class="modal" id="modal-table" tabindex="-1" role="dialog"
             data-backdrop="static" data-keyboard="false"
             aria-labelledby="select-object" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="select-object">
                            <span v-if="is_admin">{{ $lang('Dodaj nowy wpis') }}</span>
                            <span v-else>{{ $lang('Dodaj nowy komentarz') }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" @click.prevent="closeModal"
                                :aria-label="$lang('Zamknij')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="form-row">
                            <div class="form-group col-md-12 col-lg-12">
                                <div class="row">
                                    <div v-if="auth && !select_consultant" class="form-group col-4 col-lg-4">
                                        <label class="m-0 font-weight-bold" for="customer">{{
                                                $lang('Rodzaj')
                                            }}</label>
                                        <div class="row">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 m-0">
                                                <select class="form-control"
                                                        id="customer"
                                                        name="customer"
                                                        type="text"
                                                        v-model="customer" :disabled="!consultant && !taskOwner">
                                                    <option v-if="taskOwner" :value="true">{{
                                                            $lang('Komentarz')
                                                        }}
                                                    </option>
                                                    <option v-if="consultant" :value="false">{{
                                                            $lang('Opis oceny')
                                                        }}
                                                    </option>
                                                    <option v-if="!consultant && !taskOwner" :value="'brak'">{{
                                                            $lang('Brak konsultanta')
                                                        }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="auth && !customer && (consultant || select_consultant)"
                                         class="form-group col-12">
                                        <label class="m-0 font-weight-bold" for="status">{{
                                                $lang('Status')
                                            }}</label>
                                        <div class="row">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 m-0">
                                                <jira-status-select v-model="jira_status"
                                                                    :statuses="statuses"></jira-status-select>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="!customer && (consultant || select_consultant) && auth"
                                         class="form-group col-12 col-lg-12">
                                        <label class="m-0 font-weight-bold" for="status">{{
                                                $lang('Szablon')
                                            }}</label>
                                        <div class="row">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 m-0">
                                                <select class="form-control"
                                                        id="pre-comment"
                                                        name="pre-comment"
                                                        type="text"
                                                        v-model="preComment">
                                                    <option value="">{{ $lang('Wybierz...') }}</option>
                                                    <option v-for="element in preComments" :value="element"
                                                            :selected="element === preComment">{{ element.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        v-if="!customer && (consultant || select_consultant) && auth && select_consultant"
                                        class="form-group col-12 col-lg-12">
                                        <label class="m-0 font-weight-bold" for="status">{{
                                                $lang('Autor')
                                            }}</label>
                                        <div class="row">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12 m-0">
                                                <select class="form-control"
                                                        id="author"
                                                        name="author"
                                                        type="text"
                                                        v-model="author">
                                                    <option v-for="element in consultants" :value="element.id">
                                                        {{ element.surname + ' ' + element.name }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group col-12 col-lg-12">
                                        <label for="content-customer">{{ $lang('Nowy wpis') }} <small
                                            class="text-red small-70">({{ $lang('wymagane') }})</small></label>
                                        <textarea class="form-control"
                                                  id="content-customer"
                                                  name="content"
                                                  v-model="content"
                                                  rows="5"
                                                  :disabled="!(consultant || select_consultant) && !taskOwner && auth"
                                        >{{ getContent }}</textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <a href="#" class="btn btn-default" @click.prevent="closeModal">{{ $lang('Zamknij') }}</a>
                        <button id="btn-customer"
                                class="btn btn-primary float-right"
                                @click.prevent="addComment"
                                :disabled="!validateComment"
                        >{{ $lang('Dodaj') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ShowNotification from "../../mixins/show-notification";
import ToastComment from "./toast-comment";
import JiraStatusSelect from "../jira-status-select";

export default {
    components: {JiraStatusSelect, ToastComment},
    mixins: [ShowNotification],
    name: "comment-section",
    props: {
        task: Object | Array,
        comments: Object | Array | null,
        is_admin: Boolean,
        edit_mode: Boolean,
        can_admin_comment: Boolean,
        can_user_comment: Boolean,
        user_comment_section_name: String | null,
        admin_comment_section_name: String | null,
        select_consultant: {type: Boolean, required: false, default: false},
        consultants: {type: Array | Object, required: false, default: [] | {}},
        button: {type: Boolean, required: false, default: false},
        chat: {type: Boolean, required: false, default: false},
        expandable: {type: Boolean, required: false, default: false}
    },
    methods: {
        closeModal() {
            jQuery('#modal-table').modal('hide');
            this.content = null;
        },
        addComment() {
            this.clicked = true;
            var data = {
                content: this.content,
                status: (this.jira_status !== this.task.jira_status ? this.jira_status : this.task.jira_status),
                customer: this.customer,
                author: this.author
            };
            return axios.post(this.task.id + '/add-comment', data
            ).then(() => {
                window.location.reload(true);
                this.showNotification('success', 'Dodano komentarz');
            }).catch((error) => {
                console.log(error);
                const message = (error.response.data ? error.response.data : error.response.statusText);
                this.showNotification('error', (message.errors ? message.errors.content.toString() : message.message));
                this.clicked = false;
            });
        },
        getData(customer) {
            var data = {task: this.task};
            return axios.post(this.task.id + '/get-data', data
            ).then((response) => {
                this.customer = customer
                this.auth = response.data.auth;
                // this.jira_status = (response.data.task.jira_status === 1 ? 2 : response.data.task.jira_status);
                this.jira_status = response.data.task.jira_status;
                this.statuses = response.data.statuses;
                this.consultant = (((response.data.task.consultant_id)) !== null);
                this.preComments = response.data.preComments;
                this.taskOwner = response.data.taskOwner;
                if (this.auth) {
                    this.author = response.data.task.consultant_id ?? null;
                }
                if (this.consultant === false && this.auth) {
                    if (this.taskOwner) {
                        this.customer = true;
                    }
                }
            }).catch((error) => {
                console.log(error);
                const message = (error.response.data ? error.response.data : error.response.statusText);
                Object.keys(message.errors).forEach((field) => {
                    this.showNotification('error', message.errors[field].toString());
                })
            });
        },
    },
    data() {
        return {
            content: (this.preComment ? this.preComment : ''),
            customer: true,
            jira_status: (this.jira_status ? this.jira_status : ''),
            auth: '',
            statuses: '',
            consultant: false,
            template: false,
            preComments: '',
            preComment: (!this.template ? '' : this.preComment),
            taskOwner: false,
            clicked: false,
            author: null
        }
    },
    computed: {
        getContent() {
            if (this.preComment) {
                this.content = this.preComment.content + '\n' + this.content;
                this.preComment = '';
                return this.content;
            }
            this.preComment = '';
        },
        validateComment() {
            if (!((!this.consultant && !this.taskOwner && !this.select_consultant && this.auth) || this.clicked)) {
                if (this.content !== '') {
                    if (this.select_consultant) {
                        return Boolean(this.author);
                    }
                    return true;
                }
            }
            return false;
        },
        customer_comments() {
            return this.comments.filter(x => x.customer);
        },
        consultant_comments() {
            return this.comments.filter(x => !x.customer);
        }
    },
}
</script>
